<script lang="ts">
  import { page } from '$app/state';
  import { Block, ReutersLogo } from '@reuters-graphics/graphics-components';

  let { index }: { index: number } = $props();

  let hash = $derived(page.url.hash);
</script>

{#if hash || index > 0}
  <Block width="widest">
    <div class="logo" class:first={index === 0}>
      <ReutersLogo width="90px" />
    </div>
  </Block>
{/if}

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  .logo {
    width: 100%;
    max-width: 960px;
    margin: 36px auto -6rem;
    transition: all 0.2s;
    @media (max-width: 1000px) {
      margin: -2rem auto -3rem;
    }
    &.first {
      margin: 4rem auto -6rem;
      @media (max-width: 1000px) {
        margin: 4rem auto -3rem;
      }
    }
  }
</style>
